export default "__VITE_ASSET__BKfNxAJN__"